import { Formik, FormikErrors } from 'formik';
import { removeTagsFromString } from '../helpers/utils';
import { useSendMessage } from '../hooks/conversations-hooks';
import { MessageBox } from '../shared/message-box';

export interface NewMessageFormValues {
	messageText: string;
}

interface ConversationMessageBoxProps {
	onSuccess?: () => void;
}

/**
 * Wrapper around MessageBox that handles sending a new message
 */
export const ConversationMessageBox = ({ onSuccess }: ConversationMessageBoxProps) => {
	const initialValues: NewMessageFormValues = {
		messageText: '',
	};

	const validate = (values: NewMessageFormValues) => {
		const errors: FormikErrors<NewMessageFormValues> = {};
		if (!removeTagsFromString(values.messageText)) errors.messageText = 'Required Field';
		return errors;
	};

	const { sendMessage } = useSendMessage();
	const onSubmit = async (values: NewMessageFormValues) => {
		const success = await sendMessage(values);
		if (success) onSuccess?.();
	};

	return (
		<Formik<NewMessageFormValues>
			onSubmit={onSubmit}
			initialValues={initialValues}
			validate={validate}>
			<MessageBox includeSendButton />
		</Formik>
	);
};
